/**
 * ハザードレイヤーを年度指定するための設定型
 * layerName: leafletが管理するレイヤー名を自由に指定する。年切り替え処理ではこの値に"_2024"等のサフィックスが自動で付与される
 * yearConfigsは年をキーとして設定する 例: 2025: {url: string, dataLayer: string, layerName: string }
 */
export interface HazardLayerConfig {
  layerName: string;
  yearConfigs: Record<
    number,
    {
      url: string;
      dataLayer: string;
    }
  >;
}

/**
 * 指定された年とレイヤー設定から、PMTilesのURL、leafletが管理するレイヤー名、表示したいレイヤー名を取得する
 * @param year 年度
 * @param config レイヤー設定
 * @returns {} PMTilesのURL、表示したいpmtilesのレイヤー名、leafletが管理するレイヤー名、もしくはnull
 */
export const getHazardLayerProps = (
  year: number,
  config: HazardLayerConfig
): { url: string; layerName: string; dataLayer: string } | null => {
  const yearConfig = config.yearConfigs[year];
  if (!yearConfig) return null;

  return {
    url: yearConfig.url,
    dataLayer: yearConfig.dataLayer,
    layerName: `${config.layerName}_${year}`,
  };
};
